import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BusyService {

  busyRequestCount = 0;
  private isBusySubject = new BehaviorSubject<boolean>(false);
  isBusy$ = this.isBusySubject.asObservable();

  private emitIsBusy(value: boolean) {
    queueMicrotask(() => {
      this.isBusySubject.next(value);
    });
  }

  busy(){
    this.busyRequestCount++;
    this.emitIsBusy(true);
  }

  idle(){    
    this.busyRequestCount--;
    if(this.busyRequestCount <= 0){
      this.busyRequestCount = 0;
      this.emitIsBusy(false);
    } 
  }

}
